import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'
import { mq } from '../../helpers'

export const TermsWrapper = styled.div`
  padding: 50px 0;
  display: flex;
  justify-content: center;

  .content {
    max-width: 1440px;
    margin-top: 100px;
    width: 80%;

    ${mq('max', '768px')} {
      width: 90%;
    }

    hr {
      margin: 50px 0;
      border: 0.25px solid ${gsColors.ebb};
      height: 0;
    }
  }
  .copy {
    span, li, h3 {
      font-size: 22px;
    }


    .privacy {
      span {
        font-size: 22px;
      }

      p {
        margin: 15px 0;
      }

      li {
        list-style-type: none;
        margin: 15px 0;
      }

      ol {
        padding: 0;
      }
    }

    .terms {
      p {
        text-align: left;
        margin-bottom: 25px;
        font-size: 22px;
      }
    }
  }
`
